import { FC, Fragment } from 'react';

import { ADTO, CDTO, ContentfulDocument } from '@helpful/network';
import { Icon, Typography } from '@wearehelpful/ui-kit';
import { RoutePath } from '@common/constants';
import { useTranslation } from '@wearehelpful/ui-localization';

import { More, EntityLink, LinkIcon } from './ContentDefault.style';
import { useContentfulDocumentRender } from './ContentDefault.hooks';

export interface ContentDefaultProps {
  todo: ADTO.TodoLocalizedEntity;
  meta: CDTO.GetToDoMetaQuery['todoCard'];
}

export const ContentDefault: FC<ContentDefaultProps> = ({ todo, meta }) => {
  const { render } = useContentfulDocumentRender();
  const { t } = useTranslation();

  return (
    <Fragment>
      <ContentfulDocument render={render}>
        {todo?.longDescription as any}
      </ContentfulDocument>
      {!!meta?.planBenefitCollection.items.length && (
        <More>
          <Typography bold variant="p2">
            {t('forms.todoRaletedBenefits')}
          </Typography>
          {meta.planBenefitCollection.items.map(
            ({ sys: { id }, title, slug }) => {
              return (
                <EntityLink
                  key={id}
                  params={{ slug }}
                  path={RoutePath.ROOT_BENEFITS_DETAILS}
                >
                  <LinkIcon>
                    <Icon name="nav_benefits" />
                  </LinkIcon>
                  <strong>{title}</strong>
                </EntityLink>
              );
            }
          )}
        </More>
      )}
    </Fragment>
  );
};
